import { render, staticRenderFns } from "./roleName.vue?vue&type=template&id=48cb274d"
import script from "./roleName.vue?vue&type=script&lang=js"
export * from "./roleName.vue?vue&type=script&lang=js"
import style0 from "./roleName.vue?vue&type=style&index=0&id=48cb274d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports